import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    APPLICATION_MODE_NEW,
    LICENCE_STATUS_ACTIVE,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
    CanadaProvinceList,
    DOCUMENT_CONTENT_TYPE_PDF,
    REQUEST_STATUS
} from "../../../../app/constants";
import { convertFileDataForUrl } from "../../../../app/documentUploadUtils";
import { combineAddress, humanReadableDate, isSuperUser, licenceSubTypeString } from "../../../../app/utils";
import DateSelectionForm from "../../../../components/DateSelectionForm";
import DocumentViewer from "../../../../components/DocumentViewer/DocumentViewer";
import { Button, LineSeperator, NavigationLinkButton } from "../../../../components/RegularComponents";
import { canShowLoginChangeButton, companyOperatingName } from "../../../../redux/slice/applicationsUtils";
import { fetchBusinessLicnecePDF } from "../../../../redux/slice/bltDecisionSlice";
import { saveBusinessLicenceApplicationData, saveNewLoginInAgencyApplication } from "../../../../redux/slice/businessLicenceApplicationSlice";
import { setAgencyApplicationLicenceExpiryDate, setPrimaryAgencyProperty } from "../../../../redux/slice/primaryAgencyApplicationSlice";
import ApplicationStatus from '../../BLTCommon/ApplicationStatus'
import { InformationDetailPanelSection } from '../InformationDetailPanelSection'
import userAuthSelect from '../../../../redux/selector/userAuthSelector'
import ChangeLoginUserForm from "./ChangeUserLoginForm";
import { fetchRjscFromNumberAndUpdateApp } from "../../../../redux/slice/rjscSearchSlice";
import { rjscSearchSelect } from "../../../../redux/selector/rjscSearchSelector";

export const InformationTab = (props) => {
    const { licenceApplication, appData, applicationType, isArchiveApplication } = props;

    const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const [sectionToEdit, setSectionToEdit] = useState([]);
    const [fiscalEndDateError, setFiscalEndDateError] = useState(false)
    const [licenceEndDateError, setLicenceEndDateError] = useState(false)
    const [showChangeUserLoginForm, setShowChangeUserLoginForm] = useState(false)

    const { userAuth } = useSelector(userAuthSelect)
    const { rjscSearch } = useSelector(rjscSearchSelect)

    const dispatch = useDispatch()

    const expiryDate = useMemo(() => licenceApplication.endDate ? humanReadableDate(licenceApplication.endDate) : "N/A", [licenceApplication])
    const issuedDate = useMemo(() => licenceApplication.issuedDate ? humanReadableDate(licenceApplication.issuedDate) : "N/A", [licenceApplication])

    const officialsWithRJSC = useMemo(() => (
        <div style={{ display: "flex", flexDirection: "column" }}>
            {appData.companyRjscDetails?.businessData?.peopleList.map((person, index) => (
                <div key={index}>{`${person.firstName} ${person.lastName ?? ""}, ${person.position}\n`}</div>
            ))}
        </div>
    ), [appData])

    const contactNameJSX = useCallback((sectionKey) => {

        //const sectionKey = "responsibleAgent"
        if (sectionToEdit[sectionKey]) {
            const nameObject = sectionToEdit[sectionKey] ?? { firstName: "", lastName: "", phoneNumber: "", emailAddress: "" }

            const onChange = (property, value) => {
                let updatedObj = { ...sectionToEdit[sectionKey] }
                Object.defineProperty(updatedObj, property, { value: value, writable: true, enumerable: true })

                let updatedSectionToEdit = { ...sectionToEdit }
                Object.defineProperty(updatedSectionToEdit, sectionKey, {
                    value: updatedObj,
                    writable: true,
                    enumerable: true
                })
                setSectionToEdit(updatedSectionToEdit)
            }

            return (
                <fieldset className={"ns-fieldset"} id="name-edit-form">
                    <div className="ns-fieldset row bottomMarginNormal">
                        <label
                            className="ns-label"
                            autoComplete="first-name"
                            htmlFor="businessFirstNameEdit">
                            First name
                        </label>
                        <input
                            className="fw-25 ns-input"
                            type="text"
                            id="firstNameEdit"
                            name="firstNameEdit"
                            value={nameObject["firstName"]}
                            onChange={(e) => {
                                onChange("firstName", e.target.value)
                            }} />
                    </div>
                    <div className="ns-fieldset row bottomMarginNormal">
                        <label
                            className="ns-label"
                            autoComplete="last-name"
                            htmlFor="businesslastNameEdit">
                            Last name
                        </label>
                        <input
                            className="fw-25 ns-input"
                            type="text"
                            id="lastNameEdit"
                            name="lastNameEdit"
                            value={nameObject["lastName"]}
                            onChange={(e) => {
                                onChange("lastName", e.target.value)
                            }} />
                    </div>
                    <div className="ns-fieldset row bottomMarginNormal">
                        <label
                            className="ns-label"
                            autoComplete="phone-number"
                            htmlFor="phoneNumberEdit">
                            Phone
                        </label>
                        <input
                            className="fw-25 ns-input"
                            type="text"
                            id="phoneNumberEdit"
                            name="phoneNumberEdit"
                            value={nameObject["phoneNumber"]}
                            onChange={(e) => {
                                onChange("phoneNumber", e.target.value)
                            }} />
                    </div>
                    <div className="ns-fieldset row bottomMarginNormal">
                        <label
                            className="ns-label"
                            autoComplete="email-address"
                            htmlFor="emailAddressEdit">
                            Email
                        </label>
                        <input
                            className="fw-25 ns-input"
                            type="text"
                            id="emailAddressEdit"
                            name="emailAddressEdit"
                            value={nameObject["emailAddress"]}
                            onChange={(e) => {
                                onChange("emailAddress", e.target.value)
                            }} />
                    </div>
                </fieldset>
            )
        } else {
            const obj = appData[sectionKey] ?? { firstName: "", lastName: "", phoneNumber: "", emailAddress: "" }

            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>
                        <b>Name</b>
                        <span style={{ marginLeft: "10px" }}>
                            {`${obj.firstName ?? ""} ${obj.lastName ?? ""}`}
                        </span>
                    </div>
                    <div>
                        <b>Phone</b>
                        <span style={{ marginLeft: "10px" }}>
                            {obj.phoneNumber ?? ""}
                        </span>
                    </div>
                    <div>
                        <b>Email</b>
                        <span style={{ marginLeft: "10px" }}>
                            {obj.emailAddress ?? ""}
                        </span>
                    </div>
                </div>)
        }
    }, [appData, sectionToEdit])

    const email = useMemo(() => appData.mainBusinessContact?.emailAddress, [appData])
    const userEmail = licenceApplication.userEmail;

    const lastUpdated = useMemo(() => humanReadableDate(licenceApplication.modifiedDateTime), [licenceApplication])

    const handleClick = (section) => {
        let data = null
        switch (section) {
            case 'serviceCivicAddress':
                data = appData?.serviceCivicAddress ?? { address: "", city: "", postalCode: "", province: "" }
                break
            case 'serviceBusinessAddress':
                data = appData?.serviceBusinessAddress ?? { address: "", city: "", postalCode: "", province: "" }
                break
            case 'financialRecordsLocation':
                data = appData?.financialRecordsLocation ?? { address: "", city: "", postalCode: "", province: "" }
                break
            case 'responsibleAgent':
                data = appData?.responsibleAgent ?? { firstName: "", lastName: "", phoneNumber: "", emailAddress: "" }
                break
            case 'mainBusinessContact':
                data = appData?.mainBusinessContact ?? { firstName: "", lastName: "", phoneNumber: "", emailAddress: "" }
                break
            case 'complianceOfficer':
                data = appData?.complianceOfficer ?? { firstName: "", lastName: "", phoneNumber: "", emailAddress: "" }
                break
            case 'companyFiscalEndDate':
                data = appData.companyFiscalEndDate ?? 0
                break
            case 'email':
                data = email ?? ""
                break
            case 'phone':
                data = appData.mainBusinessContact?.phoneNumber ?? ""
                break
            case 'companyTrademark':
                data = appData?.companyTrademark ?? ""
                break
            default:
                data = ""
                break
        }

        if (typeof data !== "undefined") {
            let newSectionEditObj = { ...sectionToEdit }
            Object.defineProperty(newSectionEditObj, section, { value: data, enumerable: true, writable: true })
            setSectionToEdit(newSectionEditObj)
        }
    }

    const handleSave = (section) => {
        if (section === "email") {
            // appData.mainBusinessContact
            dispatch(setPrimaryAgencyProperty({
                key: "mainBusinessContact",
                value: { ...appData.mainBusinessContact, emailAddress: sectionToEdit[section] },
                changeBy: userAuth.userData.email,
                changeValidated: true
            }))
        } else if (section === "phone") {
            dispatch(setPrimaryAgencyProperty({
                key: "mainBusinessContact",
                value: { ...appData.mainBusinessContact, phoneNumber: sectionToEdit[section] },
                changeBy: userAuth.userData.email,
                changeValidated: true
            }))
        } else if (section === "endDate") {
            dispatch(setAgencyApplicationLicenceExpiryDate(sectionToEdit["endDate"]))
        } else {
            if (section === "companyFiscalEndDate") {
                //
                if (!(!!sectionToEdit[section])) {
                    setFiscalEndDateError(true)
                    return
                }
            }

            dispatch(setPrimaryAgencyProperty({
                key: section,
                value: sectionToEdit[section],
                changeBy: userAuth.userData.email,
                changeValidated: true
            }))
        }

        dispatch(saveBusinessLicenceApplicationData(applicationType, APPLICATION_MODE_NEW))
            .then(data => {
                // save successful
                let newSectionEditObj = { ...sectionToEdit }
                delete newSectionEditObj[section]
                setSectionToEdit(newSectionEditObj)
            })
            .catch(err => {
                // save error
            })
    }

    const handleLoginChangeSave = (searchedUser) => {
        if (!searchedUser) {
            return
        }

        dispatch(saveNewLoginInAgencyApplication(searchedUser))
            .then(data => {
                console.log("Login change", data)
                setShowChangeUserLoginForm(false);
            })
            .catch(err => {
                // save error
                console.log("Can not save the new login id");
            })
    }

  const updateRJSCData = () => {
    const registryNumber = appData.companyRjscDetails.businessEntity.registryNumber
    dispatch(fetchRjscFromNumberAndUpdateApp(registryNumber, applicationType))
  }

    const getApplicationLicencePDF = async (applicationId) => {
        const pdf = await fetchBusinessLicnecePDF(applicationId);
        let fileDataUrl = convertFileDataForUrl(
            pdf.file,
            DOCUMENT_CONTENT_TYPE_PDF
        );
        setDocumentViewerDocument(fileDataUrl);
        setSelectedFile(pdf);
        setOpenDocumentViewer(true);
    };

    const isCollectionAgencyType = useCallback(() => {
        return (applicationType === APPLICATION_TYPE_COLLECTION_AGENCY ||
            applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY)
    }, [applicationType])

    const isMortgageBrokerage = useCallback(() => {
        return (applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE)
    }, [applicationType])

    const isMortgageLenderAdministrator = useCallback(() => {
        return (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
            applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE)
    }, [applicationType])

    const operatingName = useCallback(() => {
        return companyOperatingName(appData)
    }, [appData])

    const provinceOptionElements = useMemo(() => {
        return Object.keys(CanadaProvinceList).map((key) => {
            const element = CanadaProvinceList[key];
            return (
                <option key={key} value={element}>
                    {element}
                </option>
            );
        });
    }, []);

    const canUpdateTrademark = () => {
        return (!companyOperatingName(appData))
    }

    const canUpdateLicenceLicenceEndDate = () => isSuperUser(userAuth.userData.email)

    const nameInputForm = (sectionKey) => {
        const nameObject = sectionToEdit[sectionKey] ?? { firstName: "", lastName: "" }

        const onChange = (property, value) => {
            let updatedObj = { ...sectionToEdit[sectionKey] }
            Object.defineProperty(updatedObj, property, { value: value, writable: true, enumerable: true })

            let updatedSectionToEdit = { ...sectionToEdit }
            Object.defineProperty(updatedSectionToEdit, sectionKey, {
                value: updatedObj,
                writable: true,
                enumerable: true
            })
            setSectionToEdit(updatedSectionToEdit)
        }
        return (
            <fieldset className={"ns-fieldset"} id="name-edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        className="ns-label"
                        autoComplete="first-name"
                        htmlFor="businessFirstNameEdit">
                        First name
                    </label>
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="firstNameEdit"
                        name="firstNameEdit"
                        value={nameObject["firstName"]}
                        onChange={(e) => {
                            onChange("firstName", e.target.value)
                        }} />
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        className="ns-label"
                        autoComplete="last-name"
                        htmlFor="businesslastNameEdit">
                        Last name
                    </label>
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="lastNameEdit"
                        name="lastNameEdit"
                        value={nameObject["lastName"]}
                        onChange={(e) => {
                            onChange("lastName", e.target.value)
                        }} />
                </div>
            </fieldset>
        )
    }

    const inputLicenceEndDateForm = (sectionKey) => {

        if (!sectionToEdit[sectionKey]) {
            sectionToEdit[sectionKey] = licenceApplication.endDate
        }

        const date = sectionToEdit[sectionKey]

        const onChange = (changedDate) => {
            setLicenceEndDateError(false)
            setSectionToEdit(Object.defineProperty({ ...sectionToEdit },
                sectionKey,
                { value: changedDate, writable: true, enumerable: true })
            )
        }

        return (
            <div
                className={
                    "ns-fieldset" +
                    ((licenceEndDateError) ? " has-error ns-fieldset-message-error" : "")
                }
            >
                <fieldset className={"ns-fieldset"}>
                    <DateSelectionForm
                        id={"company-licence-end-date"}
                        date={date}
                        showValidationError={licenceEndDateError}
                        onDateChange={onChange}
                    />
                </fieldset>
            </div>)
    }

    const inputDateForm = (sectionKey) => {
        const date = sectionToEdit[sectionKey]

        const onChange = (changedDate) => {
            setFiscalEndDateError(false)
            setSectionToEdit(Object.defineProperty({ ...sectionToEdit },
                sectionKey,
                { value: changedDate, writable: true, enumerable: true })
            )
        }

        return (
            <div
                className={
                    "ns-fieldset" +
                    ((fiscalEndDateError) ? " has-error ns-fieldset-message-error" : "")
                }
            >
                <fieldset className={"ns-fieldset"}>
                    <DateSelectionForm
                        id={"company-fiscal-end-date-date"}
                        date={date}
                        showValidationError={fiscalEndDateError}
                        hideYear
                        onDateChange={(d) => {
                            onChange(d)
                        }}
                    />
                </fieldset>
            </div>)
    }

    const inputEditForm = (sectionKey) => {
        const value = sectionToEdit[sectionKey]

        const onChange = (changedValue) => {
            setSectionToEdit(Object.defineProperty({ ...sectionToEdit },
                sectionKey,
                { value: changedValue, writable: true, enumerable: true })
            )
        }

        return (
            <fieldset className={"ns-fieldset"} id="edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="edit-form"
                        name="edit-form"
                        value={value}
                        onChange={(e) => {
                            onChange(e.target.value)
                        }}
                    />
                </div>
            </fieldset>
        )
    }

    const editAddressForm = (sectionKey, businessAddress) => {
        const onChange = (property, value) => {

            let updatedAddress = { ...sectionToEdit[sectionKey] }
            Object.defineProperty(updatedAddress, property, { value: value, writable: true, enumerable: true })

            let updatedSectionToEdit = { ...sectionToEdit }
            Object.defineProperty(updatedSectionToEdit, sectionKey, {
                value: updatedAddress,
                writable: true,
                enumerable: true
            })
            setSectionToEdit(updatedSectionToEdit)
        }

        return (
            <fieldset className={"ns-fieldset"} id="business-address-edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        className="ns-label"
                        autoComplete="street-address"
                        htmlFor="businessAddressStreetEdit">
                        Street Address
                    </label>
                    <textarea
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressStreetEdit"
                        rows={4}
                        cols={60}
                        name="city"
                        onChange={e => onChange("street", e.target.value)}>
                        {businessAddress["street"]}
                    </textarea>
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label for="businessAddressCityEdit">City</label>
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressCityEdit"
                        name="city"
                        value={businessAddress["city"]}
                        onChange={e => onChange("city", e.target.value)} />
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        id={"mra-province-select-label"}
                        className="ns-label"
                        htmlFor={"mra-province-select-input"}
                    >
                        Province
                    </label>
                    <div className="select fw-25 inlineDisplay">
                        <select
                            style={{ width: "25em" }}
                            id={"mra-province-select-input"}
                            name={"mra-province-select-input"}
                            value={businessAddress["province"] ?? ""}
                            onChange={e => onChange("province", e.target.value)}
                        >
                            {provinceOptionElements}
                        </select>
                    </div>
                </div>
                <div className="ns-fieldset row">
                    <label htmlFor="businessAddressPINEdit">Postal Code</label>
                    <input
                        type="text"
                        className="fw-25"
                        id="businessAddressPINEdit"
                        name="pin"
                        value={businessAddress["postalCode"]}
                        onChange={e => onChange("postalCode", e.target.value)}
                    />
                </div>
            </fieldset>
        )
    }

    let considerRenewalName = true;
    if (licenceApplication.licenceStatus === LICENCE_STATUS_ACTIVE) {
        considerRenewalName = false;
    }

    let serviceAddressType = appData?.serviceBusinessAddress?.street ? "serviceBusinessAddress" : "serviceCivicAddress";

    return (
      <div style={{ marginTop: "1em" }}>
        <InformationDetailPanelSection
          header={"Licence status"}
          value={<ApplicationStatus applicationStatus={licenceApplication?.applicationStatus} licenceStatus={licenceApplication?.licenceStatus} />}
        />
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Licence type"}
          value={licenceSubTypeString(licenceApplication.licencingSubType, considerRenewalName)}
        />
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Licence number"}
          value={licenceApplication.licenceNumber ?? "N/A"}
        />
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Licence PDF"}
          value={
            <NavigationLinkButton
              style={{ marginLeft: "-6px" }}
              text={licenceApplication.name}
              onClick={() => {
                // send PDF request
                let id = licenceApplication.id;

                if (isArchiveApplication) {
                  id = licenceApplication.originalApplicationId;
                }

                getApplicationLicencePDF(id);
              }}
            />
          }
        />
        <LineSeperator />

        <InformationDetailPanelSection header={"Issued on"} value={issuedDate} />
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Expiry"}
          value={"endDate" in sectionToEdit ? inputLicenceEndDateForm("endDate") : expiryDate}
        >
          {canUpdateLicenceLicenceEndDate() &&
            ("endDate" in sectionToEdit ? (
              <Button
                buttonType="regular_success"
                text={"Save"}
                disabled={isArchiveApplication}
                onClick={() => handleSave("endDate")}
              />
            ) : (
              <Button
                buttonType="regular_primary"
                text={"Edit"}
                disabled={isArchiveApplication}
                onClick={() => handleClick("endDate")}
              />
            ))}
        </InformationDetailPanelSection>
        <LineSeperator />

        {/* <InformationDetailPanelSection header={"Payment"} value={"TBD"} />
            <LineSeperator /> */}

        <InformationDetailPanelSection
          header={"Registry ID"}
          value={
            appData.companyRjscDetails?.businessData?.relatedTo ??
            appData.companyRjscDetails?.businessEntity?.registryNumber
          }
        >
          <div style={{ position: "relative", height: 50 }}>
            <Button
              buttonType="regular_primary"
              text={"Update RJSC"}
              disabled={isArchiveApplication}
              onClick={updateRJSCData}
              showSpinner={rjscSearch?.searchStatus === REQUEST_STATUS.IN_PROGRESS}
            />
            {rjscSearch?.searchStatus === REQUEST_STATUS.ERROR && (
              <div style={{ position: "absolute", color: "red", width: 250 }}>
                Error in updating RJSC details
              </div>
            )}
          </div>
        </InformationDetailPanelSection>
        <LineSeperator />

        <InformationDetailPanelSection header={"Operating name"} value={operatingName()} />
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Trademark name"}
          value={
            "companyTrademark" in sectionToEdit
              ? inputEditForm("companyTrademark", sectionToEdit["companyTrademark"])
              : appData?.companyTrademark ?? ""
          }
        >
          {canUpdateTrademark() &&
            ("companyTrademark" in sectionToEdit ? (
              <Button
                buttonType="regular_success"
                text={"Save"}
                disabled={isArchiveApplication}
                onClick={() => handleSave("companyTrademark")}
              />
            ) : (
              <Button
                buttonType="regular_primary"
                text={"Edit"}
                disabled={isArchiveApplication}
                onClick={() => handleClick("companyTrademark")}
              />
            ))}
        </InformationDetailPanelSection>
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Business address"}
          value={
            sectionToEdit["business_address"]
              ? editAddressForm("business_address", sectionToEdit["business_address"])
              : combineAddress(
                  appData.companyRjscDetails?.businessContact?.homeJurisdictionAddress ??
                    appData.companyRjscDetails?.businessContact?.civicAddress
                )
          }
        ></InformationDetailPanelSection>
        <LineSeperator />

        {(isMortgageBrokerage() || isMortgageLenderAdministrator()) && (
          <>
            <InformationDetailPanelSection
              header={"Appointed agent"}
              value={
                sectionToEdit["responsibleAgent"]
                  ? nameInputForm("responsibleAgent")
                  : `${appData.responsibleAgent?.firstName ?? ""} ${
                      appData.responsibleAgent?.lastName ?? ""
                    }`
              }
            >
              {sectionToEdit["responsibleAgent"] ? (
                <Button
                  buttonType="regular_success"
                  text={"Save"}
                  disabled={isArchiveApplication}
                  onClick={() => handleSave("responsibleAgent")}
                />
              ) : (
                <Button
                  buttonType="regular_primary"
                  text={"Edit"}
                  disabled={isArchiveApplication}
                  onClick={() => handleClick("responsibleAgent")}
                />
              )}
            </InformationDetailPanelSection>
            <LineSeperator />
          </>
        )}

        {
        /*
        For brokerage new app, Service civic address is save in serviceBusinessAddress and serviceCivicAddress is null
        */
        }
        <InformationDetailPanelSection
          header={"Address for service"}
          value={
            sectionToEdit[serviceAddressType]
              ? editAddressForm(serviceAddressType, sectionToEdit[serviceAddressType])
              : combineAddress(appData?.[serviceAddressType])
          }
        >
          {sectionToEdit[serviceAddressType] ? (
            <Button
              buttonType="regular_success"
              text={"Save"}
              disabled={isArchiveApplication}
              onClick={() => handleSave(serviceAddressType)}
            />
          ) : (
            <Button
              buttonType="regular_primary"
              text={"Edit"}
              disabled={isArchiveApplication}
              onClick={() => handleClick(serviceAddressType)}
            />
          )}
        </InformationDetailPanelSection>

        <LineSeperator />

        <InformationDetailPanelSection
          header={"Financial records location"}
          value={
            sectionToEdit["financialRecordsLocation"]
              ? editAddressForm(
                  "financialRecordsLocation",
                  sectionToEdit["financialRecordsLocation"]
                )
              : combineAddress(appData?.financialRecordsLocation)
          }
        >
          {sectionToEdit["financialRecordsLocation"] ? (
            <Button
              buttonType="regular_success"
              text={"Save"}
              disabled={isArchiveApplication}
              onClick={() => handleSave("financialRecordsLocation")}
            />
          ) : (
            <Button
              buttonType="regular_primary"
              text={"Edit"}
              disabled={isArchiveApplication}
              onClick={() => handleClick("financialRecordsLocation")}
            />
          )}
        </InformationDetailPanelSection>
        <LineSeperator />

        {(isMortgageBrokerage() || isMortgageLenderAdministrator()) && (
          <>
            <InformationDetailPanelSection
              header={"Fiscal year end date"}
              value={
                "companyFiscalEndDate" in sectionToEdit
                  ? inputDateForm("companyFiscalEndDate")
                  : humanReadableDate(appData.companyFiscalEndDate, true)
              }
            >
              {"companyFiscalEndDate" in sectionToEdit ? (
                <Button
                  buttonType="regular_success"
                  text={"Save"}
                  disabled={isArchiveApplication}
                  onClick={() => handleSave("companyFiscalEndDate")}
                />
              ) : (
                <Button
                  buttonType="regular_primary"
                  text={"Edit"}
                  disabled={isArchiveApplication}
                  onClick={() => handleClick("companyFiscalEndDate")}
                />
              )}
            </InformationDetailPanelSection>
            <LineSeperator />
          </>
        )}

        <InformationDetailPanelSection header={"Officials with RJSC"} value={officialsWithRJSC} />
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Email address"}
          value={"email" in sectionToEdit ? inputEditForm("email", sectionToEdit["email"]) : email}
        >
          {"email" in sectionToEdit ? (
            <Button
              buttonType="regular_success"
              text={"Save"}
              disabled={isArchiveApplication}
              onClick={() => handleSave("email")}
            />
          ) : (
            <Button
              buttonType="regular_primary"
              text={"Edit"}
              disabled={isArchiveApplication}
              onClick={() => handleClick("email")}
            />
          )}
        </InformationDetailPanelSection>
        <LineSeperator />

        <InformationDetailPanelSection
          header={"Login e-mail address"}
          value={
            showChangeUserLoginForm ? (
              <ChangeLoginUserForm
                userEmail={userEmail}
                application={licenceApplication}
                handleLoginChangeSave={handleLoginChangeSave}
              />
            ) : (
              userEmail
            )
          }
        >
          {canShowLoginChangeButton(licenceApplication) ? (
            <Button
              buttonType="regular_primary"
              text={showChangeUserLoginForm ? "Cancel" : "Change"}
              disabled={isArchiveApplication}
              onClick={() => setShowChangeUserLoginForm(!showChangeUserLoginForm)}
            />
          ) : null}
        </InformationDetailPanelSection>
        <LineSeperator />

        {(isMortgageBrokerage() || isMortgageLenderAdministrator()) && (
          <>
            <InformationDetailPanelSection
              header={"Phone number"}
              value={
                "phone" in sectionToEdit
                  ? inputEditForm("phone", sectionToEdit["phone"])
                  : appData.mainBusinessContact?.phoneNumber ?? ""
              }
            >
              {"phone" in sectionToEdit ? (
                <Button
                  buttonType="regular_success"
                  text={"Save"}
                  disabled={isArchiveApplication}
                  onClick={() => handleSave("phone")}
                />
              ) : (
                <Button
                  buttonType="regular_primary"
                  text={"Edit"}
                  disabled={isArchiveApplication}
                  onClick={() => handleClick("phone")}
                />
              )}
            </InformationDetailPanelSection>
            <LineSeperator />
          </>
        )}

        {isCollectionAgencyType() && (
          <>
            <InformationDetailPanelSection
              header={"Compliance officer"}
              value={contactNameJSX("complianceOfficer")}
            >
              {sectionToEdit["complianceOfficer"] ? (
                <Button
                  buttonType="regular_success"
                  text={"Save"}
                  disabled={isArchiveApplication}
                  onClick={() => handleSave("complianceOfficer")}
                />
              ) : (
                <Button
                  buttonType="regular_primary"
                  text={"Edit"}
                  disabled={isArchiveApplication}
                  onClick={() => handleClick("complianceOfficer")}
                />
              )}
            </InformationDetailPanelSection>
            <LineSeperator />
          </>
        )}

        {isCollectionAgencyType() && (
          <>
            <InformationDetailPanelSection
              header={"Responsible agent"}
              value={contactNameJSX("responsibleAgent")}
            >
              {sectionToEdit["responsibleAgent"] ? (
                <Button
                  buttonType="regular_success"
                  text={"Save"}
                  disabled={isArchiveApplication}
                  onClick={() => handleSave("responsibleAgent")}
                />
              ) : (
                <Button
                  buttonType="regular_primary"
                  text={"Edit"}
                  disabled={isArchiveApplication}
                  onClick={() => handleClick("responsibleAgent")}
                />
              )}
            </InformationDetailPanelSection>
            <LineSeperator />
          </>
        )}

        {isCollectionAgencyType() && (
          <>
            <InformationDetailPanelSection
              header={"Business contact"}
              value={contactNameJSX("mainBusinessContact")}
            >
              {sectionToEdit["mainBusinessContact"] ? (
                <Button
                  buttonType="regular_success"
                  text={"Save"}
                  disabled={isArchiveApplication}
                  onClick={() => handleSave("mainBusinessContact")}
                />
              ) : (
                <Button
                  buttonType="regular_primary"
                  text={"Edit"}
                  disabled={isArchiveApplication}
                  onClick={() => handleClick("mainBusinessContact")}
                />
              )}
            </InformationDetailPanelSection>
            <LineSeperator />
          </>
        )}

        <InformationDetailPanelSection header={"Last updated"} value={lastUpdated} />

        <DocumentViewer
          fileData={documentViewerDocument}
          isOpen={openDocumentViewer}
          fileName={selectedFile?.filename}
          handleClose={() => setOpenDocumentViewer(false)}
        />
      </div>
    );
}
